import { jsx } from 'react/jsx-runtime';
import { GenericConfigSection } from './GenericConfigSection.js';

const ConfigSection = ({ children, ...props }) => {
  return /* @__PURE__ */ jsx(GenericConfigSection, { ...props, kind: "section", children });
};

export { ConfigSection };
//# sourceMappingURL=ConfigSection.js.map
